import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.51 9.655v4.357c0 .676-2.467 1.632-5.51 1.632s-5.51-.956-5.51-1.632V9.655m13.84-.932v6.758m0 0a1.224 1.224 0 0 0 0 2.449m0-2.45a1.224 1.224 0 1 1 0 2.45m0 0v2.833m-8.33-9.2L2.205 8.081 12 4.625l9.795 3.456z",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }